import { render, staticRenderFns } from "./PromotionSchedule.vue?vue&type=template&id=61e81d7a"
import script from "./PromotionSchedule.vue?vue&type=script&lang=js"
export * from "./PromotionSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e81d7a')) {
      api.createRecord('61e81d7a', component.options)
    } else {
      api.reload('61e81d7a', component.options)
    }
    module.hot.accept("./PromotionSchedule.vue?vue&type=template&id=61e81d7a", function () {
      api.rerender('61e81d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/quick/PromotionSchedule.vue"
export default component.exports